import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import KindergartenOverview from "src/components/panel/kindergarten/KindergartenOverview";

const KindergartenView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("kindergarten_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb title={t("kindergarten_title")} />
        <KindergartenOverview />
      </Sidebar>
    </>
  );
};

export default KindergartenView;
